import { render, staticRenderFns } from "./country-select.vue?vue&type=template&id=58883dc0&"
import script from "./country-select.vue?vue&type=script&lang=js&"
export * from "./country-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports